// extracted by mini-css-extract-plugin
export default {"main":"Lcatable_main__ZyKC+","tablehead":"Lcatable_tablehead__qdXS8","custom-striped-table":"Lcatable_custom-striped-table__yaryS"};